<script>

	import {PRConnect} from "@projectroom/ui-lib";
	import axios from "axios";
	import EmojiSelector from 'svelte-emoji-selector';

	export let event;
	
	let refThumbnailContent, refThumbnailTitle, refThumbnailSubTitle;

	const onThumbnailContentFileUpload = (e) => {
        let image = e.target.files[0];
        const key = `common/event/${event.id}/${image.name}`;
		const type = image.type;
        PRConnect.send("/api/File/uploadPresignedUrl", {key, type}, data => {
            axios.put(data.result, image, {headers: {"Content-Type": type}})
            .then( response =>{
                event.changeThumbnailContent(image.name);
				event = event;
            });
        });  
    }

	const clickThumbnailDelete = () => {
		event.deleteThumbnailContent();
		event = event;
	}

	const onEmoji = (e, type) => {
        if (type == "SUB") {
            changeThumbnailSubTitle(e.detail);
        } else {
            changeThumbnailTitle(e.detail);
        }
    }

    const changeThumbnailTitle = (addedContext = "") => {
        const title = refThumbnailTitle.value.slice(0, refThumbnailTitle.selectionEnd) + addedContext + refThumbnailTitle.value.slice(refThumbnailTitle.selectionEnd);
		event.changeThumbnailTitle(title);
    }
    const changeThumbnailSubTitle = (addedContext = "") => {
        const subTitle = refThumbnailSubTitle.value.slice(0, refThumbnailSubTitle.selectionEnd) + addedContext + refThumbnailSubTitle.value.slice(refThumbnailSubTitle.selectionEnd);
        event.changeThumbnailSubTitle(subTitle);
    }
</script>

<div data-w-tab="Tab 1" class="w-tab-pane" class:w--tab-active={event.currentTab === "thumbnail"} id="event-thumbnail">
	{#if event.isLoad}
	<div class="event-thumbnail-write-wrap">
		<div class="event-write">
		<div class="admin-title-text">썸네일 이미지</div>
		<div class="event-thumbnail-image">	
			{#if event.getThumbnailContent()}
				<img class="thumbnail-content" src={event.getThumbnailContent()} />
				<img loading="lazy" src="/static/images/trashcan-icon.svg" class="logo-image-delete" on:click={clickThumbnailDelete}>
			{:else}
			<img src="https://uploads-ssl.webflow.com/6305dccb2939dad9c631e36f/64b7852fd75bbfcf43e8d2b1_upload-icon-big.svg" loading="lazy" alt="" class="image-153">
			<div>
				<a href="#" class="image-upload-button w-button" on:click={refThumbnailContent.click()}>썸네일 이미지 업로드</a>
				<input accept="image/png, image/jpeg, image/jpg" bind:this={refThumbnailContent} type="file" name="add" on:change={onThumbnailContentFileUpload} hidden>
			</div>
			{/if}
		</div>
		<div class="admin-title-text">썸네일 텍스트</div>
		<div class="linktext-block-form">
			<div class="text-block-94">타이틀 텍스트</div>
			<div class="linktext-input-form-copy w-form">
			<div id="email-form" name="email-form" data-name="Email Form" method="get" class="link-form admin" data-wf-page-id="65026a62cce9ccd6eb77d46a" data-wf-element-id="16303937-9d30-8000-67bb-bd79736b782f" aria-label="Email Form">
				<input type="text" class="name-text-form w-input" bind:this={refThumbnailTitle} autofocus="true" value={event.thumbnailTitle} maxlength="256" name="name-4" data-name="Name 4" placeholder="ex) 썸네일 타이틀" on:change={()=>changeThumbnailTitle()}>
				<EmojiSelector on:emoji={onEmoji} />
			</div>
			</div>
		</div>
		<div class="linktext-block-form">
			<div class="text-block-94">서브 텍스트</div>
			<div class="linktext-input-form-copy w-form">
			<div id="email-form" name="email-form" data-name="Email Form" method="get" class="link-form" data-wf-page-id="65026a62cce9ccd6eb77d46a" data-wf-element-id="7571a7b8-9238-b42c-64da-7228c2483fd8" aria-label="Email Form">
				<input type="text" class="name-text-form w-input" bind:this={refThumbnailSubTitle} autofocus="true" value={event.thumbnailSubTitle} maxlength="256" name="name-4" data-name="Name 4" placeholder="ex) 썸네일 서브 타이틀" on:blur={()=>changeThumbnailSubTitle()} on:change={()=>changeThumbnailSubTitle()}>
				<EmojiSelector on:emoji={(e)=>onEmoji(e,"SUB")} />
			</div>
			</div>
		</div>
		</div>
	</div>
	{/if}
</div>
<style>
	.thumbnail-content {
		width: 300px;
		border-radius: 10px;
	}

	.event-thumbnail-image {
		position: relative;
	}

	.logo-image-delete {
		right: 15px;
		top: 15px;
		position: absolute;
		cursor: pointer;
	}
	.image-153 {
		margin-top: 0px;
		margin-left: 0px;
	}
	.link-form {
		position: relative;
	}
	.name-text-form {
		width: 100%;
	}
</style>